"use strict";

exports.__esModule = true;
exports.StatisticsLogger = undefined;

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var StatisticsLogger = exports.StatisticsLogger = function () {
  function StatisticsLogger() {
    (0, _classCallCheck3["default"])(this, StatisticsLogger);
  }

  StatisticsLogger.prototype.log = function log(info, token) {
    var logString = "";
    (0, _keys2["default"])(info).forEach(function (k) {
      return logString += info[k] + ",";
    });
    this.send(logString, token);
  };

  StatisticsLogger.prototype.send = function send(logString, token) {
    var xhr = (0, _utils.createXHR)();
    var count = 0;
    xhr.open("POST", "https://uplog.qbox.me/log/3");
    xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
    xhr.setRequestHeader("Authorization", "UpToken " + token);
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        if (xhr.status !== 200) {
          count++;
          count <= 3 ? xhr.send(logString) : "";
        }
      }
    };
    xhr.send(logString);
  };

  return StatisticsLogger;
}();


//////////////////
// WEBPACK FOOTER
// ./src/statisticsLog.js
// module id = 109
// module chunks = 0